import React from 'react';
import './HomeLogos.scss';

import { HOME_CREATOR_ALTERNATE_LOGOS, HOME_BRAND_ALTERNATE_LOGOS } from '../../../Helpers/home_helpers';
import PropTypes from 'prop-types';

const HomeLogos = props => {
  const { forBrands } = props;
  const goToSite = logo => {
    window.open(`https://${logo.domain}`, '_blank');
  };
  const logos = forBrands ? HOME_BRAND_ALTERNATE_LOGOS : HOME_CREATOR_ALTERNATE_LOGOS;
  return (
    <div className={`home-logos-outer-container ${forBrands ? 'dark' : ''}`}>
      <div className='home-logos-inner-container'>
        <div className={`badge ${forBrands ? 'dark' : ''}`}>Select Partners</div>
        <div className='logos'>
          {logos.map((logo, index) => (
            <div onClick={() => goToSite(logo)}  className={`logo-container ${forBrands ? 'dark' : ''}`} key={index}>
              <img className={`logo ${forBrands ? 'dark' : ''}`} src={logo.logo} alt={logo.brand} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

HomeLogos.propTypes = {
  forBrands: PropTypes.bool,
};

export default HomeLogos;
